import React, { useState } from 'react'
import { Form, Button, InputGroup } from "react-bootstrap"
import users from "../img/users.svg";
import ConfirmatoryModal from "../Components/ConfirmatoryModal";
import * as formik from 'formik';
import * as yup from 'yup';
import { saveUser, handleSubmit, handleChange, getModalData } from "../Functions/myfunctions";
import { useNavigate } from 'react-router-dom';


function NewUser() {
    const { Formik } = formik;
    const [errorMessage, setErrorMessage] = useState("");

    const [modalShow, setModalShow] = React.useState(false);
    const [actionName, setActionName] = useState({ name: '', action: '', values: '' });
    const [urlLink, setUrlLink] = useState();
    const [validated, setValidated] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        userName: "",
        password: "",
        password2: "",
        role: "",
    })


    const NewUserSchema = yup.object().shape({
        name: yup.string()
            .required('A név kitöltése kötelező'),
        userName: yup.string()
            .required('A felhasználónév kitöltése kötelező'),
        password: yup.string()
            .matches(/[0-9]/, "A jelszónak tartalmaznia kell számot.")
            .matches(/[a-z]/, "A jelszónak tartalmaznia kell kis betűt")
            .matches(/[A-Z]/, "A jelszónak tartalmaznia kell nagy betűt")
            .min(12, 'A jelszónak minimum 12 hosszúnak kell lennie!')
            .required('A jelszó megadása kötelező'),
        password2: yup.string()
            .required('A megerősítő jelszó kitöltése kötelező')
            .oneOf([yup.ref('password'), null], "A jelszónak és a megerősítő jelszónak meg kell egyeznie"),
        role: yup.string()
            .required('Szerepkör választása kötelező'),
    });


    const save = (values, actions) => {
        getModalData({ name: 'Kívánja a felhasználót létrehozni?', action: 'save', values: values }, "", modalShow, setActionName, setUrlLink, setModalShow);
    }

    const confirmationfunction = (event) => {
        event.preventDefault();
        const dataCopy = { ...actionName.values };
        delete dataCopy['password2'];
        dataCopy["sessionToken"] = sessionStorage.getItem("sessionToken");
        dataCopy["active"] = 1;
        saveUser(dataCopy, setErrorMessage);
        setModalShow(false);
    }

    const navigate = useNavigate();

    const navigateToUsers = () => {
        // 👇️ navigate to /users
        navigate('/users');
    };


    return (
        <div className="form-page-content" >
            <div className='custom-title'><img src={users} alt="new-user-icon" /><h1>Új felhasználó</h1></div><br />
            <Formik
                initialValues={{
                    name: "",
                    userName: "",
                    password: "",
                    password2: "",
                    role: "",
                }}
                validationSchema={NewUserSchema}
                onSubmit={(values, actions) => {
                    save(values, actions);
                }}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="validationFormikName">
                            <Form.Label >
                                Név*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="text" placeholder="Név" name="name" required value={values.name} onChange={handleChange} isInvalid={!!errors.name} />
                                <Form.Control.Feedback type="invalid" tooltip>{errors.name}</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="validationFormikUserName">
                            <Form.Label >
                                Felhasználónév*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="text" placeholder="Felhasználónév" required name="userName" value={values.userName} onChange={handleChange} isInvalid={!!errors.userName} />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.userName}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="validationFormikPassword">
                            <Form.Label >
                                Jelszó*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Jelszó" name="password" value={values.password} onChange={handleChange} required autoComplete='new-password' isInvalid={!!errors.password} />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.password}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="validationFormikPassword2">
                            <Form.Label >
                                Jelszó újra*
                            </Form.Label>
                            <InputGroup hasValidation>
                                <Form.Control type="password" placeholder="Jelszó újra" name="password2" value={values.password2} onChange={handleChange} required autoComplete='new-password' isInvalid={!!errors.password2} />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.password2}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="role">
                            <InputGroup hasValidation >
                                <Form.Label >Szerepkör*</Form.Label>
                                <Form.Select aria-label="role select " defaultValue="Szerepkör" onChange={handleChange} isInvalid={!!errors.role} >
                                    <option disabled>Szerepkör</option>
                                    <option value="admin">Admin</option>
                                    <option value="user">Általános felhasználó</option>
                                </Form.Select>
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {errors.role}
                                </Form.Control.Feedback>
                            </InputGroup>

                        </Form.Group>
                        <Form.Group className="mb-3 form-buttons">
                            <Button type="submit" className="form-custom-button">Mentés</Button><Button onClick={navigateToUsers} className='form-delete-button'>Mégsem</Button>
                        </Form.Group>
                        {errorMessage !== "" ? <p className="error mb-3">{errorMessage}</p> : ""}
                    </Form>
                )}
            </Formik>
            <ConfirmatoryModal actionname={actionName} urllink={urlLink} confirmationfunction={confirmationfunction}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    )

}

export default NewUser;
